import { LICENSE_STATUS } from '../../../../../config/constants'
import TenantLicenseForm from '../TenantLicensesForm/TenantLicensesForm'

import type { UpdateLicenseProps } from './UpdateLicense.props'

function UpdateLicense(props: UpdateLicenseProps) {
  const { isEditFormOpen, initialValues, onClose, onSubmit } = props

  // Map API response (camelCase) to form fields (snake_case)
  const mappedInitialValues = initialValues
    ? {
        package: initialValues.package,
        startDate: initialValues.startDate,
        endDate: initialValues.endDate,
        status: initialValues.status,
      }
    : undefined

  const licenseActive = mappedInitialValues?.status === LICENSE_STATUS.ACTIVE
  const editMode = !!mappedInitialValues
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const pastDate =
    new Date(mappedInitialValues?.startDate ?? new Date()) < today

  return (
    isEditFormOpen && (
      <TenantLicenseForm
        initialValues={mappedInitialValues}
        titleKey="Tenants.Profile.Licenses.Form.EditTitle"
        disabled={false}
        isEditMode={editMode}
        isLicenseActive={licenseActive}
        isPastDate={pastDate}
        onSubmit={onSubmit}
        onCancel={onClose}
        onClose={onClose}
      />
    )
  )
}

export default UpdateLicense
